import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export const toggleModal: Modal.Toggle = Modal.toggleModal(Constants.ADD_FILTER_GROUP_TAG)
export const updateModalField: Modal.Update = Modal.updateModal(Constants.ADD_FILTER_GROUP_TAG)

interface FetchFilterGroupPayload extends Request.RequestOptions { filterGroupId: Types.FilterGroupId}

export const fetchFilterGroup = (community: string, filterGroupId: Types.FilterGroupId) =>
  Request.requestActionCreator<FetchFilterGroupPayload>(Constants.FETCH_FILTER_GROUP)({
    filterGroupId,
    method: 'GET',
    url: `/filters/${community}/${filterGroupId}`,
  })

export const createTags: Modal.SubmitWithId<Types.ModalData> =
  (id: Modal.Id, community: string, data: Types.ModalData) =>
  Request.requestActionCreator(Constants.ADD_FILTER_GROUP_TAG)({
    method: 'PUT',
    payload: data,
    url: `/filters/${community}/${id}`,
  })

export const updateStatus: IsActive.UpdateStatusAction = (community: string, stateChange: IsActive.StateChange) =>
  Request.requestActionCreator(Constants.UPDATE_FILTER_GROUP_TAG)({
    method: 'PUT',
    payload: IsActive.asUpdateBody(stateChange),
    url: `/filters/${community}/groups/${stateChange.id}`,
  })

export const fetchFilterGroups = (community: string) =>
  Request.requestActionCreator<Request.RequestOptions>(Constants.FETCH_FILTER_GROUPS)({
    method: 'GET',
    url: `/filters/${community}/groups`,
})

export const createFilterGroupAction = (eventName: string): Modal.Submit<Types.ModalData> =>
  (community: string, data: Types.ModalData) =>
  Request.requestActionCreator(eventName)({
    method: 'POST',
    payload: data,
    url: `/filters/${community}`,
  })



// WEBPACK FOOTER //
// ./src/pages/filter-group/actions.ts